/**
 * Handles the "Show more" toggle on collapsed property-list category groups.
 *
 * Each grouped category type renders only its first few tiles (the list carries
 * .property-list--collapsible.is-collapsed) followed by a button with
 * [data-show-more-toggle]. Clicking the button expands or re-collapses the list.
 *
 * This module should be initialized once on DOMContentLoaded. It uses event
 * delegation on the document so it keeps working for property lists that are
 * swapped in dynamically (e.g. by the AJAX booking filter or Barba.js).
 */

/**
 * Finds the collapsible property-list associated with a "Show more" button.
 * The button is rendered immediately after its .property-list sibling.
 * @param {HTMLElement} button
 * @returns {HTMLElement|null}
 */
function getListForButton(button) {
    const wrap = button.closest('.property-list__show-more');
    const list = wrap ? wrap.previousElementSibling : null;
    return list && list.classList.contains('property-list--collapsible') ? list : null;
}

export function initializePropertyListShowMore() {
    // Guard against attaching the delegated listener more than once.
    if (window.rmsShowMoreListener) {
        return;
    }
    window.rmsShowMoreListener = true;

    document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-show-more-toggle]');
        if (!button) {
            return;
        }

        const list = getListForButton(button);
        if (!list) {
            return;
        }

        const isCollapsed = list.classList.toggle('is-collapsed');
        button.setAttribute('aria-expanded', String(!isCollapsed));
        button.textContent = isCollapsed ? 'Show more' : 'Show less';
    });
}
